let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kPASh")).then(() => parcelRequire('e9FZe'));